import { toast } from "react-toastify";
import { api } from "../../../../../Api/Api";
import * as Yup from "yup";

export const handleAboutUsSubmit = (values: any, actions: any, setIsOpen: Function, refetch: Function, editMode: boolean) => {
    if (editMode) {
        const id = values?.id
        api
            .patch(`/about/${id}`, values, true)
            .then(async function ([success, response]: any) {
                refetch()
                setIsOpen(false)
                toast.success("Updated Successfully",{toastId:"aboutupdate"})
            })
            .catch((err) => {
                if (err?.response?.data?.message?.[0]?.body) {
                    actions?.setFieldError("body", err?.response?.data?.message?.[0]?.body)
                }
                toast.error("Unexpected Error Occurred",{toastId:"aboutupdaterr"});
                actions.setSubmitting(false);
            });
    }
    else {
        api
            .post(`/about`, values, true)
            .then(async function ([success, response]: any) {
                refetch()
                setIsOpen(false)
                toast.success("Added Successfully",{toastId:"aboutadded"})
            })
            .catch((err) => {
                toast.error("Unexpected Error Occurred",{toastId:"aboutadder"});
                actions.setSubmitting(false);
            });
    }
}

export async function getAboutUsData(currentPage: string) {
    const [, data] = await api.get(`/about?page=${currentPage}&perPage=10`, true);
    return data?.data
}

export const onAboutEditClickHandler = (
    selectedId: any,
    setModalEditData: Function,
    setIsOpen: Function,
    data: any
) => {
    setModalEditData([]);
    setModalEditData(
        data?.data?.filter((itm: any) => itm?.id === selectedId)
    );
    setIsOpen(true);
};

export const handleAboutUsInitializer = (setAboutUsInitialValue: Function, modalEditData: any, AboutUsValues: any) => {
    if (modalEditData?.length !== 0) {
        setAboutUsInitialValue({
            id: modalEditData?.[0]?.id,
            title: modalEditData?.[0]?.title,
            body: modalEditData?.[0]?.body
        })
    }
    else {
        setAboutUsInitialValue(AboutUsValues)
    }
}

export const aboutStatusClickHandler = (
    selectedId: string | number,
    refetch: Function,
    newStatus: number
) => {
    api
        .patch(`/about/publish/${selectedId}`, { status: newStatus }, true)
        .then(async function ([success, response]: any) {
            refetch();
            toast.success("Updated",{toastId:"publisupdate"});
        })
        .catch((err) => {
            toast.error("Unexpected Error Occurred");
        });
};

export const aboutDeleteClickHandler = (
    selectedId: string | number,
    refetch: Function
) => {
    api
        .delete(`/about/${selectedId}`, {}, true)
        .then(async function ([success, response]: any) {
            refetch();
            toast.success("Deleted",{toastId:"aboutdelete"});
        })
        .catch((err) => {
            toast.error("Unexpected Error Occurred",{toastId:"aboutdeleter"});
        });
};

export const aboutUsValidationSchema = Yup.object().shape({
    title: Yup.string().required("Field  is required"),
    body: Yup.string()
        .required("Field is required")
        .min(10, "The  minimmum  10 characters."),
});